import React from 'react';

const USE_CASES = [
  'Christmas client gifts',
  'Employee & team appreciation',
  'Holiday parties',
  'Thank-you gifts',
  '2027 client outreach',
  'New-year relationship building',
  'Closing gifts',
  'Events & presentations',
];

const CorpUseCases = () => (
  <section className="ff-section" data-testid="corp-usecases" style={{ paddingTop: 56, paddingBottom: 56 }}>
    <div className="ff-container ff-text-center">
      <p className="ff-eyebrow">WHAT PEOPLE ORDER IT FOR</p>
      <h2 style={{ fontSize: 'clamp(1.5rem, 3vw, 2.25rem)' }}>Thank Your Clients. Celebrate Your Team. Start 2027 Right.</h2>
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 10, marginTop: 24 }}>
        {USE_CASES.map((u) => (
          <span key={u} style={{
            padding: '10px 18px', borderRadius: 999, fontSize: 14, fontWeight: 600,
            background: 'var(--ff-cream)', color: 'var(--ff-burgundy)', border: '1px solid rgba(114,47,55,0.25)',
          }}>{u}</span>
        ))}
      </div>
    </div>
  </section>
);

export default CorpUseCases;
